import React from "react";
import { Link } from "react-router-dom";

/**
 * Footer sits at the bottom of every page (via Layout). It shows
 * copyright information plus quick links to the most important pages.
 */
const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      style={{
        backgroundColor: "var(--bg-secondary)",
        borderTop: "1px solid var(--border)",
        padding: "2rem 1.5rem",
      }}
    >
      <div
        className="container"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        <p style={{ fontSize: "0.875rem", color: "var(--text-dim)" }}>
          © {year} Kambham Srihari Reddy. All rights reserved.
        </p>
        <div style={{ display: "flex", gap: "1.5rem", flexWrap: "wrap" }}>
          <Link
            to="/"
            style={{ fontSize: "0.875rem", color: "var(--text-muted)" }}
          >
            Home
          </Link>
          <Link
            to="/projects"
            style={{ fontSize: "0.875rem", color: "var(--text-muted)" }}
          >
            Projects
          </Link>
          <Link
            to="/blogs"
            style={{ fontSize: "0.875rem", color: "var(--text-muted)" }}
          >
            Blog
          </Link>
          <Link
            to="/contact"
            style={{ fontSize: "0.875rem", color: "var(--text-muted)" }}
          >
            Contact
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
